import { EventEmitter } from "events";
import { accessTokenModel } from "../Model/AccessTokenModel";

class AccountVM extends EventEmitter {
    public loadToken() {
        return accessTokenModel.token;
    }
}

const accountVM = new AccountVM;
export default accountVM;